/* eslint-disable no-console */
import React from 'react';
// @material-ui/core components
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import PromotedAdPackagesCreate from 'components/PromotedAdPackages/Create';
import { useQueryString } from 'helpers/effects';

const ScreenPromotedAdPackagesCreate = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <PromotedAdPackagesCreate initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPromotedAdPackagesCreate;
